import { FC, ReactNode } from 'react';
import { render } from 'storyblok-rich-text-react-renderer-ts';

import { RichText } from '../../types/Franchises';
import { RichTextLink } from '../RichTextLink';

interface Props {
  mainTitle?: boolean;
  paragraphs: RichText[];
  title: string;
}

const paragraph = (children: ReactNode) => (
  <p className="aa-prose mb-3 max-w-none last-of-type:mb-0">{children}</p>
);

export const TextGroup: FC<Props> = ({
  mainTitle = false,
  paragraphs,
  title,
}) => (
  <section className="grid-section w-full gap-y-6">
    <div className="col-span-12 lg:col-span-4">
      {mainTitle ? (
        <h1 className="text-md font-bold md:text-lg">{title}</h1>
      ) : (
        <h2 className="text-md font-bold md:text-lg">{title}</h2>
      )}
    </div>
    {paragraphs.map((p) => (
      <div key={p._uid} className="col-span-12 md:col-span-6 lg:col-span-4">
        {render(p.richText, {
          markResolvers: { link: RichTextLink },
          nodeResolvers: { paragraph },
        })}
      </div>
    ))}
  </section>
);
